import React from 'react'
import { View , Text,TouchableOpacity, Image} from 'react-native';
import styles from '../../styles/AppStyles';
import { useAuth } from '../hooks/useAuth';

export const Navbar = () => {

     const { signOut, email } = useAuth();
   
     const handleLogout =async () => {
      await signOut();
     };

  return (
    <>
     <View style={styles.navBar}>
        <View style={styles.navBarLeft}>
          <Image
            source={require('../../assets/header.png')} style={{ resizeMode: 'contain', width: 190, height: 65 }}
          />
        </View>
        <View style={styles.navBarRight}>
          <Text style={styles.navBarText}>
            Logged in as {email}
          </Text>
          <TouchableOpacity onPress={handleLogout} style={styles.logoutButton}>
            <Text style={styles.logoutButtonText}>Log off</Text>
          </TouchableOpacity>
        </View>
      </View>
    </>
  )
}
